import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './header-skeleton.scss';

export const HeaderSkeleton = memo(({ withCtaSkeleton = false }) => (
  <Row className="header-skeleton d-flex align-content-stretch w-100 mb-1_5 pos-r">
    <Col xs="auto">
      <Skeleton className="photo-skeleton d-block rounded-12" />
    </Col>
    <Col xs={6} md={5} className="d-flex flex-column justify-content-center">
      <Skeleton className="rounded-6 height-22" />
      <Skeleton className="mt-0_5 rounded-6 height-22 w-75" />
    </Col>
    {withCtaSkeleton && (
      <Col md={4} className="d-flex flex-column justify-content-center hidden-md-down">
        <Skeleton className="cta pos-a rounded-8 height-40 right-0" />
      </Col>
    )}
  </Row>
));

HeaderSkeleton.displayName = 'HeaderSkeleton';
HeaderSkeleton.propTypes = {
  withCtaSkeleton: PropTypes.bool,
};
